import {API_URL} from '@/config';
import type {LoginBody} from '@/domain/commonTypes';
import type {User} from '@/domain/entities/User';
import type {AuthService} from '@/domain/interfaces/AuthService';
import {HttpError} from '@/infrastructure/implementations/HttpClient/jsonHttpClient';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';

const CREATE_TOKEN_URL = '/auth/jwt/login';
const ME_URL = 'me';

export class RestAuthService implements AuthService {
  constructor(private readonly httpClient: HttpClient) {}
  create = (body: LoginBody) => {
    const data = new URLSearchParams();
    data.append('username', body.email);
    data.append('password', body.password);

    return fetch(API_URL + CREATE_TOKEN_URL, {
      body: data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
    }).then(async (response) => {
      if (response.status >= 200 && response.status < 300 && response.ok) {
        return response.json();
      } else {
        // WARNING this can't be expressed in Typescript, but: Statuses other than 2xx are rejected with an HttpError.
        const text = await response.text();

        throw new HttpError(response.status, text);
      }
    });
  };
  me = () => {
    return this.httpClient.get<User>(ME_URL);
  };
}
